import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// Capitulos X (Ascensores) + XI (Garajes). Render condicional por cap.
export default function AscensoresGarajesPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const cv = config.capitulosVisibles;
  const verAsc = !!cv.ascensores;
  const verGar = !!cv.garajes;
  const secNum = String(pagNum - 2).padStart(2, "0");

  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Circulación</span>
        <h2 className="big">Circulación <em>{verAsc && verGar ? "vertical y vehicular." : verAsc ? "vertical." : "vehicular."}</em></h2>

        {verAsc && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.ascensores}</div>
              <h3 className="art-title">Ascensores — uso y cuidado</h3>
            </div>
            <ol className="rules">
              <li><span className="m">a</span><span>Oprimir solo el botón de la parada deseada.</span></li>
              <li><span className="m">b</span><span>No alterar la marcha del ascensor con la llave de comando.</span></li>
              <li><span className="m">c</span><span>No sobrecargar; respetar la <b>carga máxima</b>.</span></li>
              <li><span className="m">d</span><span>Evitar maltrato de aberturas, paredes y botoneras.</span></li>
            </ol>
          </div>
        )}

        {verGar && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.garajes}</div>
              <h3 className="art-title">Garajes</h3>
            </div>
            <div className="hours-grid">
              <div className="hours-card"><div className="lbl">Velocidad máx.</div><div className="val">10 km/h</div></div>
              <div className="hours-card"><div className="lbl">Acceso</div><div className="val">Control remoto</div><div className="note">Excepción: portero</div></div>
              <div className="hours-card"><div className="lbl">Bauleras</div><div className="val">Metálicas</div><div className="note">Disposición Bomberos</div></div>
            </div>
            <ol className="rules">
              <li><span className="m">a</span><span>Vehículos solo en cochera asignada.</span></li>
              <li><span className="m">b</span><span>Prohibido estacionar fuera de los lugares establecidos.</span></li>
              <li><span className="m">c</span><span>Se recomienda mantener vehículos cerrados con llave.</span></li>
              <li><span className="m">d</span><span>Prohibido cualquier juego (patín, pelota, bicicleta, skate).</span></li>
              <li><span className="m">e</span><span>Destino exclusivo: estacionamiento (incluye bicicletas y embarcaciones).</span></li>
              <li><span className="m">f</span><span>Estacionar dentro de los límites de la cochera.</span></li>
              <li><span className="m">g</span><span>Prohibido depositar mercaderías, muebles u objetos peligrosos.</span></li>
              <li><span className="m">h</span><span>Uso exclusivo de residentes: <b>prohibido subarrendar</b> a no residentes.</span></li>
              <li><span className="m">i</span><span>Cerrar las puertas del garaje al ingresar y salir.</span></li>
              <li><span className="m">j</span><span><b>Prohibido depositar bidones con nafta</b> o líquidos inflamables.</span></li>
            </ol>
          </div>
        )}
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
